export const themeOptions = {
  'Light': 'secondary',
  'Dark': 'dark',
  'Red': 'danger',
  'Yellow': 'warning',
  'Green': 'success',
  'Blue': 'primary',
  'Teal': 'info'
}
